import { render, staticRenderFns } from "./UserImport.vue?vue&type=template&id=0132b33b&scoped=true&"
import script from "./UserImport.vue?vue&type=script&lang=js&"
export * from "./UserImport.vue?vue&type=script&lang=js&"
import style0 from "./UserImport.vue?vue&type=style&index=0&id=0132b33b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132b33b",
  null
  
)

export default component.exports